import React, { useState } from "react";
import { Header, Box } from "@InnoUI";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useSelector } from "react-redux";
import InnoIcons from "@InnoIcons";
import { useNavigate } from "react-router";
import { getRoleName, isAdmin } from "@utils/helper";
import { LogoutAction } from "@store/auth/actions";
import { useDispatch } from "react-redux";
import themet from "theme";
import SupportComponent from "components/SupportComponent";
import AddEditCompany from "views/AdminSettings/Companies/AddEditCompany";

function HeaderLayout() {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openModalView, setOpenModalView] = useState(false);

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const placeholderSearch = "search here...";
  // const authData = useSelector((state) => state?.authdata?.data?.user || []);
  const authData = useSelector((state) => state?.authdata?.data || []);

  const accessLevel = useSelector(
    (state) => state?.authdata?.data?.userType || 0
  );

  const profileData = [
    {
      name: authData?.fullName,
      id: authData?.id,
      designation: getRoleName(accessLevel),
      onClick: () => alert("Settings clicked"),
      visible: true,
      rightIcon: InnoIcons.KeyboardArrowDownIcon,
      disabled: false,
      options: [
        {
          menuItem: "Admin Settings",
          id: "acc",
          onClick: () => navigate("/admin-settings"),
          icon: (
            <InnoIcons.SettingsIcon
              sx={{
                height: "15px",
                weight: "15px",
                color: themet.colors.themeColor,
              }}
            />
          ),
          disabled: !isAdmin(accessLevel),
          url: "/admin-settings",
        },
        {
          menuItem: "Change Password",
          id: "acc",
          onClick: () => navigate("/change-password"),
          icon: (
            <InnoIcons.ChangePassword
              sx={{
                height: "15px",
                weight: "15px",
                color: themet.colors.themeColor,
              }}
            />
          ),
          url: "/change-password",
        },
        {
          menuItem: "Support",
          id: "support",
          onClick: () => setOpenModalView(true),
          icon: (
            <InnoIcons.SupportAgentIcon
              sx={{
                height: "15px",
                weight: "15px",
                color: themet.colors.themeColor,
              }}
            />
          ),
        },
        {
          menuItem: "Log out",
          id: "logout",
          onClick: () => {
            dispatch(LogoutAction());
          },
          icon: (
            <InnoIcons.LogoutIcon
              sx={{
                height: "15px",
                weight: "15px",
                color: themet.colors.themeColor,
              }}
            />
          ),
          disabled: false,
        },
      ],
    },
  ];

  const handleSearch = (query) => {
    console.log("Search query:", query);
  };

  return (
    <>
      <Box>
        <Header
          visibilityOptions={{
            icon: false,
            searchbar: false,
            pages: true,
            projects: true,
            placeholderSearch: true,
            position: true,
            profileData: true,
          }}
          profileData={profileData}
          placeholderSearch={placeholderSearch}
          onSearch={handleSearch}
          isMobile={isMobile}
        />
      </Box>
      {openModalView && (
        <SupportComponent
          setOpenModalView={setOpenModalView}
          openModalView={openModalView}
        />
      )}
    </>
  );
}

export default HeaderLayout;
